module.exports = __webpack_public_path__ + "static/img/icon_help@2x.b6e4a65d.png";